export const ResponseMessageTypes = {
    GetSourcesList: 'getSourcesList',
    GetSource: 'getSource',
    GetQueryList: 'getQueryList',
    GetQueryById: 'getQueryById',
    CreateQuery: 'createQuery',
    DeleteQuery: 'deleteQuery',
    SaveQuery: 'saveQuery',
    GetDashboardsList: 'getDashboardsList',
    GetDashboardById: 'getDashboardById',
    getDashboards: 'getDashboards',
    CreateDashboard: 'createDashboard',
    DeleteDashboard: 'deleteDashboard',
    SaveDashboard: 'saveDashboard',
    GetData: 'getData',
    GetSourceDTC: 'getSourceDTC',
    Notification: 'notification',
}
